export const createImage = (url) =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = "anonymous"; // Aby sme zabránili CORS problémom
        image.src = url;

        image.onload = () => resolve(image);
        image.onerror = (error) => reject(error);
    });
